module.exports = __webpack_public_path__ + "ab80a3237a44820ef94e65252de53e6f.png";